import api from './api';

const listPillsToolkit = query => api.get('/api/pill-tools/', { params: query });

export default {
  listPillsToolkit,
};
